'use strict';

exports.__esModule = true;

var _inject = require('./inject');

var _inject2 = _interopRequireDefault(_inject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _inject2['default'])('props');


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/functions/injectProps.js
// module id = 574
// module chunks = 1